export const comments_5129829 = {"data":{"data":[],"links":{}}}